import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { payrollTabs } from '../../../routes/purchases';

const Summary = () => {
  const tabs = payrollTabs();
  return <FingoPaper tabs={tabs} />;
};

export default Summary;
